import { useLocalization } from '@akinon/next/hooks';

export const SpecialPageSellerInfo = ({ data }) => {
  const { t } = useLocalization();
  return (
    <div className="mx-[18px] md:mx-0 my-4 md:my-20 border border-gray-900 rounded-sm px-2 lg:px-6 pt-5 pb-7 md:pt-9 md:pb-[54px]">
      <div className="text-secondary font-bold text-sm md:text-base leading-8">
        {t('category.seller_info')}:
      </div>
      <div className="mt-8 flex flex-col gap-4">
        {data?.attributes?.seller_info?.map((info, index) => (
          <div key={index} className="text-sm md:text-base">
            <div className="leading-6">{info.value.info_key}</div>
            <div className="font-bold leading-6">{info.value.info_value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
